//import ThemeButton from "components/Buttons/ThemeButton";
import ThemeButton from "components/Buttons/ThemeButton";
import styled from "styled-components";

export const Container = styled.div<{ scale: number }>`
	font-size: 17px;
	width: 21.375em;
	height: 36.0625em;
	background-color: white;
	border-radius: 16px;
	overflow: hidden;
	transform: scale(${(props) => props.scale});

	display: flex;
	flex-direction: column;
	align-items: center;

	@media (orientation: landscape) {
		flex-direction: row;
		font-size: 16px;
		width: 59.75em;
		height: 25.625em;
	}
`;

export const Header = styled.div`
	position: relative;
	height: 32%;
	width: 100%;
	background-color: #c7c7c7;
	display: flex;
	align-items: center;
	justify-content: center;
	color: rgba(0, 0, 0, 0.25);
	font-family: Inter;
	font-weight: 700;
	font-size: 1em;
	text-transform: uppercase;
	letter-spacing: 0.15em;

	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;

	@media (orientation: landscape) {
		height: 100%;
		width: 50%;
	}
	//top: 0;
`;

export const Body = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	flex-direction: column;
	width: 90%;
	height: 68%;
	//top: 6%;
	//left: 50%;
	//transform: translateX(-50%);
	gap: 0.8em;

	@media (orientation: landscape) {
		width: 50%;
		height: 100%;
		//top: 1.4em;
		//right: 1.6em;
		//left: unset;
		//transform: unset;
		gap: 0.4em;
	}
`;

export const Items = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 1rem;
`;

export const Title = styled.div`
	color: #113b62;
	text-align: center;
	font-family: Baloo;
	font-size: 2.125em;
	font-style: normal;
	font-weight: 400;
	line-height: 0.9em;

	@media (orientation: landscape) {
		font-size: 3em;
		line-height: 0.8em;
		padding: 0em 2em;
	}
`;

export const SubTitle = styled.div`
	color: #333;
	text-align: center;
	font-family: Inter;
	font-size: 1em;
	font-style: normal;
	font-weight: 700;
	line-height: 1.2em;

	@media (orientation: landscape) {
		font-size: 1em;
	}
`;

export const Footer = styled.div`
	color: #333;
	font-family: Inter;
	font-size: 0.75em;
	font-style: normal;
	font-weight: 700;
	line-height: 1.6em;
	text-align: center;

	@media (orientation: landscape) {
		font-size: 1em;
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	//margin-top: 6.7em;

	@media (orientation: landscape) {
		margin-top: unset;
	}
`;

export const Button = styled(ThemeButton)`
	padding: 0.2em;
	width: 90%;
	height: 3.56em;
	//font-size: 0.7em;
`;

export const Box = styled.div`
	background-color: rgba(0, 0, 0, 0.25);
	border-radius: 15px;
	font-size: 1.5em;
	width: 4.2em;
	height: 4.2em;
	display: flex;
	justify-content: center;
	align-items: center;

	@media (orientation: landscape) {
		font-size: 1.65em;
	}
`;

export const RewardItem = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	position: relative;
	//padding: 0.21em;
`;

export const RewardAmountContainer = styled.div`
	position: absolute;
	min-width: 120%;
	display: flex;
	align-items: center;
	justify-content: center;
	bottom: -0.8em;
`;

export const RewardAmount = styled.div`
	color: #fff;
	font-weight: 700;
	font-size: 1.25em;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: right;
	font-family: "Baloo";
	font-weight: 300;
	text-shadow: 0.071em 0.071em 0em #000;
	-webkit-text-stroke-width: 0.12em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
`;

export const ItemImage = styled.img`
	min-width: 2.5em;
	height: 2.5em;
	object-fit: contain;
	justify-self: center;
	align-self: center;
`;
